import { BRAND } from "../lib/brand";

// Official LIVYVIO running-sprout mascot. Used selectively (hero, tools, helpful/
// empty/success states, goals). Decorative instances pass alt="" (empty).
export function Mascot({ className = "h-10 w-10", floaty = false, alt = "", eager = false }) {
  return (
    <img
      src={BRAND.mascot}
      alt={alt}
      aria-hidden={alt ? undefined : true}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={`${className} ${floaty ? "animate-floaty" : ""} object-contain select-none`}
      draggable={false}
    />
  );
}
